import React, { useEffect, ReactNode } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useAuthStore } from '@/stores/auth.store'
import { AuthContext } from './auth-context'

interface AuthProviderProps {
  children: ReactNode
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const {
    user,
    isLoading,
    isAuthenticated,
    isAdmin,
    isViewer,
    isReseller,
    isWholesaler,
    isNeoPlatform,
    isImpersonating,
    initializeAuth,
    login,
    validateCode,
    logout,
    refreshUser,
    hasRole,
    hasAnyRole,
  } = useAuthStore(
    useShallow(state => ({
      user: state.user,
      isLoading: state.isLoading,
      isAuthenticated: state.isAuthenticated,
      isAdmin: state.isAdmin,
      isViewer: state.isViewer,
      isReseller: state.isReseller,
      isWholesaler: state.isWholesaler,
      isNeoPlatform: state.isNeoPlatform,
      isImpersonating: state.isImpersonating,
      initializeAuth: state.initializeAuth,
      login: state.login,
      validateCode: state.validateCode,
      logout: state.logout,
      refreshUser: state.refreshUser,
      hasRole: state.hasRole,
      hasAnyRole: state.hasAnyRole,
    }))
  )

  useEffect(() => {
    initializeAuth()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoading,
        isAuthenticated,
        login,
        validateCode,
        logout,
        refreshUser,
        hasRole,
        hasAnyRole,
        isAdmin,
        isViewer,
        isReseller,
        isWholesaler,
        isNeoPlatform,
        isImpersonating,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
